import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import RoomInfoCard from '../components/RoomInfoCard.vue';
let Rooms = class Rooms extends Vue {
};
__decorate([
    Prop({ required: true, type: Array })
], Rooms.prototype, "rooms", void 0);
__decorate([
    Prop({ required: false, type: String })
], Rooms.prototype, "controllerName", void 0);
__decorate([
    Prop({ required: false, default: '' })
], Rooms.prototype, "keyPrefix", void 0);
Rooms = __decorate([
    Component({
        components: {
            RoomInfoCard,
        },
    })
], Rooms);
export default Rooms;
